/**
 * Created by lihanying on 2017/6/29.
 */

export const GETCLUBSTORAGE = 'GETCLUBSTORAGE'



// WEBPACK FOOTER //
// ./src/containers/ClubStorage/constants.js